import { router } from "AppRoutes";
import { RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { SessionProvider } from "providers/SessionProvider";
import { QuizProvider } from "providers/QuizProvider";
import i18n from "./utils/i18n";
import "./App.scss";
import "components/css/style.css";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <SessionProvider>
        <QuizProvider>
          <RouterProvider router={router} />
        </QuizProvider>
      </SessionProvider>
    </I18nextProvider>
  );
}

export default App;
